// Input validation & sanitization utilities

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[+\d\s\-()]{0,20}$/;

export function sanitizeText(str) {
  if (typeof str !== 'string') return '';
  return str.trim().slice(0, 1000);
}

export function isValidEmail(email) {
  return typeof email === 'string' && EMAIL_REGEX.test(email.trim()) && email.length <= 254;
}

export function isValidPhone(phone) {
  if (!phone) return true; // optional field
  return typeof phone === 'string' && PHONE_REGEX.test(phone.trim());
}

export function isValidName(name) {
  return typeof name === 'string' && name.trim().length >= 2 && name.trim().length <= 100;
}

export function isValidMessage(message) {
  return typeof message === 'string' && message.trim().length >= 10 && message.trim().length <= 2000;
}

// Simple in-memory rate limiter (per-session, client-side)
const rateLimitMap = new Map();

export function checkRateLimit(key, maxAttempts = 3, windowMs = 60000) {
  const now = Date.now();
  const entry = rateLimitMap.get(key);

  if (!entry) {
    rateLimitMap.set(key, { count: 1, windowStart: now });
    return true;
  }

  if (now - entry.windowStart > windowMs) {
    rateLimitMap.set(key, { count: 1, windowStart: now });
    return true;
  }

  if (entry.count >= maxAttempts) {
    return false;
  }

  entry.count++;
  return true;
}
